import { render, staticRenderFns } from "./ConnectedBankAccount.vue?vue&type=template&id=23474ffc&scoped=true"
import script from "./ConnectedBankAccount.vue?vue&type=script&lang=js"
export * from "./ConnectedBankAccount.vue?vue&type=script&lang=js"
import style0 from "./ConnectedBankAccount.vue?vue&type=style&index=0&id=23474ffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23474ffc",
  null
  
)

export default component.exports